import { render, staticRenderFns } from "./department-manag.vue?vue&type=template&id=440584ac"
import script from "./department-manag.vue?vue&type=script&lang=js"
export * from "./department-manag.vue?vue&type=script&lang=js"
import style0 from "./department-manag.vue?vue&type=style&index=0&id=440584ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports